import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { RootState } from '../../../../redux';
import InputSymbol from '../../CommonFunctions/InputSymbol';
import { updateFormatOption } from '../../../../redux/ChartPoperties/ChartControlsActions';
import React from 'react';

/**
 * This component is rendered by GaugeChartFormatting
 * @returns a UI component having a input for enter a currency
 */

const CurrencyInput = ({
  searchIn,
  propKey,
  iconColor,
}: {
  searchIn: string;
  propKey: string;
  iconColor?: string;
}) => {
  const { gaugeChartFormats } = useSelector((state: RootState) => ({
    gaugeChartFormats: state.chartControls.properties[propKey].formatOptions.gaugeChartFormats,
  }));

  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <div
        className="optionDescription"
        style={{ marginTop: '2px', marginBottom: '0px', color: iconColor }}
      >
        Currency Symbol
      </div>
      <div
        style={{
          padding: '0 4px',
          marginTop: '0px',
          marginBottom: '8px',
          marginLeft: '2px',
          marginRight: '2px',
        }}
      >
        <input
          id="currency-symbol-input"
          type="text"
          value={gaugeChartFormats[searchIn]?.currencySymbol ?? '$'}
          onChange={(e) => {
            const updatedValue = { ...gaugeChartFormats[searchIn], currencySymbol: e.target.value };
            dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
          }}
          style={{
            width: '100%',
            height: '26px',
            border: '1px solid rgb(211, 211, 211)',
            borderRadius: '4px',
            padding: '0 8px',
            backgroundColor: 'white',
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default CurrencyInput;
